$(document).on('turbolinks:load', function () {
    document.querySelector('.timeline-panel.current')?.scrollIntoView({ block: "end", inline: "center" } )
})